import React from "react";
import LegalPage from "./LegalPage";

export default function Contact() {
  return <LegalPage pageKey="contact" testId="contact-page" />;
}
